export default "/mendel-portrait.png";